/**
 * Display helpers for the Communities module. Dates are shown in the viewer's
 * locale; an absent value is an em dash, never an invented one.
 */

export function formatDateTime(iso: string | null | undefined): string {
  if (!iso) return "—";
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return "—";
  return d.toLocaleString(undefined, {
    year: "numeric",
    month: "short",
    day: "numeric",
    hour: "numeric",
    minute: "2-digit",
  });
}

export function formatDate(iso: string | null | undefined): string {
  if (!iso) return "—";
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return "—";
  return d.toLocaleDateString(undefined, { year: "numeric", month: "short", day: "numeric" });
}

/** "Maria Santos (@maria)", "@maria", "Maria Santos", or a fallback. */
export function personLabel(
  p: { name: string | null; handle: string | null } | null | undefined,
  fallback = "Unknown",
): string {
  if (!p) return fallback;
  if (p.name && p.handle) return `${p.name} (@${p.handle})`;
  if (p.handle) return `@${p.handle}`;
  return p.name ?? fallback;
}
